import * as React from 'react';
import { getEngagementSourceFromUrl, trackView } from 'services/client/analytics/engagement';
import CourtPageContent from './CourtPageContent';
import { Props } from './types';

export default function CourtPageV2(props: Props) {
  const venueId = props.venue?.id;

  // Engagement: record a club/venue-page view. Source comes from the `?src=` param
  // when the visitor arrived from another surface, else OTHER (direct/SEO).
  React.useEffect(() => {
    if (venueId) {
      trackView({
        entityType: 'CLUB_PAGE',
        entityId: venueId,
        source: getEngagementSourceFromUrl(),
      });
    }
  }, [venueId]);

  // Auth modals (and the anonymous signup nudge) live in CourtPageContent, which
  // owns the signup-success auto-follow handler — a second instance here would
  // mount duplicate dialogs and open a signup without that handler.
  return (
    <>
      <CourtPageContent {...props} />
      {!!props.jsonLd && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: props.jsonLd }} />
      )}
    </>
  );
}
